export default __webpack_public_path__ + "static/media/card2.577b9789.png";